<template>
  <c-container form wide>
    <c-book-header>ステーションを選択</c-book-header>

    <template v-if="areas.length === 0">
      <c-no-station/>
    </template>

    <template v-else>
      <c-area
        v-for="area in areas"
        :key="area.pref"
        :area="area"
      />
    </template>

  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CNoStation from './CNoStation'
import CArea from './CArea'

import * as api from '@/api'
import * as prefectures from '@/libs/prefectures'

export default {
  name: 'Stations',
  mixins: [
    page('ステーションを選択')
  ],
  components: {
    CBookHeader,
    CNoStation,
    CArea
  },

  async prepare (to) {
    const orgcode = to.params.orgcode

    // ステーション一覧を取得する
    const resp = await api.getStations(orgcode)

    return {
      stations: resp.data
    }
  },

  props: {
    stations: Array
  },

  computed: {
    // 表示すべき特徴
    features () {
      return enumFeatures(this.stations)
    },

    // エリア一覧
    areas () {
      const stations = Array.from(this.stations)

      // stations を地域順にソートする
      stations.sort((x, y) => {
        if (x.profile.x0402 !== y.profile.x0402) {
          return x.profile.x0402 - y.profile.x0402
        }
        return x.stationID - y.stationID
      })

      // エリア一覧を返す
      return getAreas(stations, this.features)
    }
  }
}

/**
 * 特徴を列挙する
 */
function getFeatures (meta) {
  return {
    airport: !!meta.airports,
    station: !!meta.stations,
    keykey: !!meta.services.keykey
  }
}

/**
 * 表示すべき特徴を列挙する
 *
 * @param {Array} data ステーション一覧
 * @returns {Array} 特徴一覧を返す
 */
function enumFeatures (data) {
  // ステーション全体で使用されている特徴を洗い出す
  return data.reduce((result, st) => {
    const feats = getFeatures(st.meta)
    return {
      airport: result.airport | feats.airport,
      station: result.station | feats.station,
      keykey: result.keykey | feats.keykey
    }
  }, {
    airport: false,
    station: false,
    keykey: false
  })
}

/**
 * 表示に適した形式に変換する
 *
 * @param {Array} data ステーション一覧
 * @returns {Array} 表示に適した形式でステーション一覧を返す
 */
function getAreas (data) {
  const areas = []
  let current = null

  for (let i = 0, len = data.length; i < len; ++i) {
    const st = data[i]
    const pref = prefectures.getName(st.profile.x0402)
    const mapped = {
      stationID: st.stationID,
      shopID: st.shopID,

      name: st.profile.name,
      image: st.profile.image,

      x0402: st.profile.x0402,
      pref,
      address: st.profile.address,
      phone: st.profile.phone,
      access: st.profile.access,
      map: st.profile.map,

      workTime: st.profile.workTime,

      features: getFeatures(st.meta)
    }

    if (!current) {
      // 新しく current を作成する
      current = {
        pref,
        stations: [mapped]
      }
    } else if (current.pref !== pref) {
      // current を areas に追加する
      areas.push(current)

      // 新しく current を作成する
      current = {
        pref,
        stations: [mapped]
      }
    } else {
      // current.station に mapped を追加する
      current.stations.push(mapped)
    }
  }

  if (current) {
    // current を areas に追加する
    areas.push(current)
  }

  return areas
}
</script>
